import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LoginForm from '../../forms/Login';
import PasswordResetRequestForm from '../../forms/PasswordResetRequest';
import PasswordResetFormComponent from '../../forms/PasswordResetForm';
import { Route, Routes } from "react-router-dom";
import { withRouter } from '../../utils/withRouter';
import { resettingPassword } from '../../actions/authActions';


class AuthenticationComponent extends Component {
    componentWillMount() {
        if (this.props.location.pathname.includes("reset")) {
            this.props.resettingPassword()
        }
    }
    render() {
        return (
            <div className="screen authentication">
                <div className="cover authentication">
                    <Routes>
                        {(this.props.mode === 'default' || this.props.mode === 'password') && (
                            <Route exact path='/reset/:id/:token' element={<PasswordResetFormComponent />} />
                        )}
                        <Route path='*' element={this.props.mode === 'reset' ? <PasswordResetRequestForm/> : <LoginForm />} />
                    </Routes>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        mode: state.auth.mode
    }
};
AuthenticationComponent.propTypes =
{
    mode: PropTypes.string
};
export default withRouter(connect(mapStateToProps, {resettingPassword})(AuthenticationComponent))